import clsx from 'clsx';
import React from 'react';

import useEffectiveColorMode from '../../../hooks/useEffectiveColorMode';

function APIErrorMessage({ className, children }) {
  const isDarkMode = useEffectiveColorMode() === 'dark';

  return (
    <div
      className={clsx(
        'my-4 rounded-lg border px-4 py-3 text-center',
        isDarkMode
          ? 'border-orange-900 bg-orange-950 text-orange-300'
          : 'border-orange-200 bg-orange-50 text-orange-700',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default APIErrorMessage;
